import "./InviteWithEmail.scss"

import { Button, Input, TextTag as Text } from "../../atoms"
import {
  INVITEE_EMAIL_PLACEHOLDER,
  INVITE_BUTTON,
  INVITE_EMAIL_LABEL,
  NICKNAME_REQUIRED,
} from "../../constants/messages"
import _ from "../../utils/lodashUtils"
import { Form } from "antd"
import { INVITE_FAILURE } from "../../constants/notificationMsg"
import { InviteeEmailValidation } from "../../validationSchema/InviteeEmailValidation"
import React from "react"
import { withFormik } from "formik"
import { ActivityIndicator } from "../ActivityIndicator"

const FormItem = Form.Item

class S extends React.PureComponent {
  handleValidation = (e) => {
    e.preventDefault()
    const { handleSubmit, values, nickName, setNickNameError } = this.props
    if (!nickName) {
      setNickNameError(NICKNAME_REQUIRED)
      if (!values.inviteeEmail) handleSubmit()
      return
    } else {
      setNickNameError("")
    }
    handleSubmit()
  }

  render() {
    const {
      values,
      handleChange,
      handleBlur,
      touched,
      errors,
      inviteOperationLoading,
    } = this.props
    return (
      <div id="inviteWithEmail" className="invite-with-email">
        <form name="invite_email" onSubmit={this.handleValidation}>
          <div id="detailsRow">
            <FormItem
              validateStatus={
                touched.inviteeEmail && errors.inviteeEmail ? "error" : null
              }
            >
              <Text className="invite-label">{INVITE_EMAIL_LABEL}</Text>
              <Input
                name="inviteeEmail"
                value={values.inviteeEmail}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder={INVITEE_EMAIL_PLACEHOLDER}
                autoComplete="off"
                disabled={this.props.isDisabled || this.props.isInvited}
                error={
                  touched.inviteeEmail && errors.inviteeEmail
                    ? errors.inviteeEmail
                    : ""
                }
              />
              {values.inviteeEmail &&
                touched.inviteeEmail &&
                !errors.inviteeEmail &&
                this.props.status &&
                this.props.status.prevEmail === values.inviteeEmail &&
                this.props.isInvited !== null &&
                !this.props.isInvited && (
                  <div className="label-error">
                    {INVITE_FAILURE("email address")}
                  </div>
                )}
            </FormItem>
          </div>
          <div className="footer-btn-box">
            <Form.Item>
              <Button
                btnSize="large"
                btnType="primary"
                htmlType="submit"
                className="login-form-button"
                disabled={
                  this.props.isDisabled ||
                  !_.isEmpty(errors.inviteeEmail) ||
                  inviteOperationLoading
                }
              >
                {inviteOperationLoading && <ActivityIndicator />}
                {INVITE_BUTTON(this.props.nickName)}
              </Button>
            </Form.Item>
          </div>
        </form>
      </div>
    )
  }
}

export default withFormik({
  enableReinitialize: true,
  validationSchema: InviteeEmailValidation,
  mapPropsToValues: (props) => ({
    inviteeEmail: props.inviteeEmail ? props.inviteeEmail : "",
  }),
  handleSubmit: async (values, { props, setStatus }) => {
    props.invite("EMAIL", values, props.nickName).then((success) => {
    })
      .catch(() => {
        setStatus({ prevEmail: values.inviteeEmail })
      })
  },
})(S)
